// The admin token lives only in this device's browser storage (Preview test page).
const KEY = 'spike.adminToken';

export function readStoredToken(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function storeToken(token: string): void {
  try {
    localStorage.setItem(KEY, token);
  } catch {
    // Private mode or blocked storage: the token just won't be remembered.
  }
}

export function clearStoredToken(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Nothing to clear.
  }
}
